import ProvisionalReceiptTypeSelection from './ProvisionalReceiptTypeSelection';

export default ProvisionalReceiptTypeSelection;